import React, { Component } from 'react'
import styled from 'styled-components'
import CloseIcon from '../../UI/Icons/CloseIcon'
import { device } from '../../../utils/helpers'
import PurchaseForm from '../../Forms/Purchase'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Header = styled.div`
  text-align: center;
  position: relative;
`

const Title = styled.h4`
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  padding: 25px;
  color: #4d4d4d;
  font-size: 18px;
  text-align: center;

  @media ${device.mobileMinL} {
    font-size: 16px;
  }

  @media ${device.tablet} {
    font-size: 24px;
  }

  @media ${device.laptop} {
    font-size: 28px;
    padding: 30px;
  }

  @media ${device.laptopL} {
    font-size: 36px;
  }
`

const Icon = styled(CloseIcon)`
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 10px;
  width: 20px;

  @media ${device.laptop} {
    width: 30px;
  }

  &:hover {
    fill: ${props => props.theme.color.hoverPrimary};
  }
`

const Content = styled.div`
  padding: 25px 30px;
  height: auto;
  justify-content: center;
  display: flex;
  flex-direction: column;

  @media ${device.tablet} {
    padding: 45px 100px;
  }
`

class InfoPopup extends Component {
  closeIconClick () {
    this.props.closeModal()
  }

  render () {
    return (
      <Wrapper>
        <Header>
          <Icon fill='#4d4d4d' onClick={this.closeIconClick.bind(this)} />
        </Header>
        <Content>
          <Title>INSERISCI I TUOI DATI E SALVA<br /> IL PREVENTIVO!<br /> TI INVIEREMO UNA MAIL<br /> CON IL RIEPILOGO</Title>
          <PurchaseForm {...this.props} />
        </Content>
      </Wrapper>
    )
  }
}

export default InfoPopup



// WEBPACK FOOTER //
// ./src/components/Pages/Strutture/EnquiryPopup.js